import { MD } from "./types";

const defaultState = {
    reference: {
        isFetching: false,
        error: null,
        isInView: false,
        data: {},
    },
    exRates: {},
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case MD.MD_SET_REF_FETCH_STATUS:
            return {
                ...state,
                reference: {
                    ...state.reference,
                    isFetching: action.isFetching,
                    error: action.error,
                },
            };
        case MD.MD_TOGGLE_REF_SIDEBAR:
            const isInView =
                typeof action.shouldOpen === "boolean"
                    ? action.shouldOpen
                    : !state.reference.isInView;

            return {
                ...state,
                reference: {
                    ...state.reference,
                    isInView,
                },
            };
        case MD.MD_SAVE_REF_DATA:
            return {
                ...state,
                reference: {
                    ...state.reference,
                    data: action.data,
                    isFetching: false,
                },
            };
        case MD.MD_RESET_REF:
            return {
                ...state,
                reference: { ...defaultState.reference },
            };
        case MD.MD_SET_EX_RATES:
            return {
                ...state,
                exRates: action.rates,
            };
        default:
            return state;
    }
};
